export default "<div class=\"blue\">\n  <div class=\"white\">\n    <app-expert-analysis-consultation></app-expert-analysis-consultation>\n  </div>\n</div>\n";